import React from "react";
import AGModal from "../Modal";
import { INotificationModalProps } from "./NotificationModal.props";

const NotificationModal: React.FC<INotificationModalProps> = (
    {
        visible,
        toggleModal,
        ...props
    }: INotificationModalProps
) => {

    return <AGModal
        toggleModal={toggleModal}
        visible={visible}
        footer={null}
        title=""
        setMaxHeight={450}
        setHeightHeader={47}
        isMaxContent={true}
    >
        {props.children}
    </AGModal>
}

export default React.memo(NotificationModal);